<template>
  <div class="container">
    <!-- Header -->
    <Header></Header>
    <div class="head-img">
      <div class="img-item" v-for="(item,index) in headImg" :key="index">
        <img :src="item.img" :class="{'is-show':item.id == indexId}">
      </div>
    </div>
    <!-- 二级导航-->
      <div class="second-banner">
        <div v-for="(item,index) in secbanner" :key="index">
          {{item}}
        </div>
      </div>
    <!--支撑体系-->
    <div class="hold" v-if="holdInfo.length > 0">
      <h2>支撑体系</h2>
      <div class="common-border"></div>
      <div class="hold-container">
        <div class="hold-item" v-for="(item,index) in holdInfo" :key="index">
          <div class="hold-img" :data-id="index">
            <img :src="item.advantageImg">
          </div>
        </div>
      </div>
    </div>

    <div class="introduce" v-if="introduceInfo.length > 0">
      <h2>产品能力</h2>
      <div class="common-border"></div>
      <h4>以客户视角为基础逻辑，以数据为中心，构建可感知、可持续的体系框架，让客户能发挥产业数字化转型的潜力</h4>
      <div class="introduce-container">
        <div class="introduce-item" v-for="(item,index) in introduceInfo" :key="index">
          <div class="introduce-img" :data-id="index">
            <img :src="item.advantageImg">
          </div>
          <div class="introduce-title">{{item.advantageTitle}}</div>
          <div class="introduce-text" :data-id="index">{{item.advantageText}}</div>
        </div>
      </div>
    </div>

    <!--产品创新-->
    <div class="platform" v-if="platformInfo.length > 0">
      <h2>产品创新</h2>
      <div class="common-border"></div>
      <div class="platform-container">
        <div class="platform-item" v-for="(item,index) in platformInfo" :key="index">
          <div class="platform-text">
            <div class="platform-content">{{item.advantageText}}</div>
          </div>
          <div class="platform-img">
            <img :src="item.advantageImg">
          </div>
        </div>
      </div>
    </div>

    <!--用户价值-->
    <div class="uservalue" v-if="userValueInfo.length > 0">
      <h2>用户价值</h2>
      <div class="common-border"></div>
      <div class="uservalue-container">
        <div class="uservalue-item" v-for="(item,index) in userValueInfo" :key="index">
          <div class="uservalue-img">
            <img :src="item.advantageImg">
          </div>
          <div class="uservalue-text">
            <div class="uservalue-content">{{item.advantageText}}</div>
          </div>
        </div>
      </div>
    </div>

    <!--核心优势-->
    <div class="advantage" v-if="advantageInfo.length > 0">
      <h2>核心优势</h2>
      <div class="common-border"></div>
      <div class="advantage-container">
        <div class="advantage-item" v-for="(item,index) in advantageInfo" :key="index" :class="{'is_full':2 ==index}">
          <div class="advantage-img">
            <img :src="item.advantageImg">
          </div>
          <div class="advantage-text">
            <div class="advantage-title">{{item.advantageTitle}}</div>
            <div class="advantage-content">{{item.advantageText}}</div>
          </div>
        </div>
      </div>
    </div>
    <!--应用场景-->
    <div class="scenario" v-if="scenarioInfo.length > 0">
      <h2>应用场景</h2>
      <div class="common-border"></div>
      <div class="scenario-container">
        <div class="scenario-item" v-for="(item,index) in scenarioInfo" :key="index">
          <div class="scenario-text" :data-id="index">
            <div class="scenario-title">{{item.advantageTitle}}</div>
            <div class="scenario-content">{{item.advantageText}}</div>
          </div>
          <div class="scenario-img" :data-id="index">
            <img :src="item.advantageImg">
          </div>
        </div>
      </div>
    </div>
    <!--客户案例-->
    <div class="case" v-if="caseInfo.length > 0">
      <h2>客户案例</h2>
      <div class="common-border"></div>
      <div class="case-container">
        <div class="case-item" v-for="(item,index) in caseInfo" :key="index" :data-id="index" @mouseover="selectStyle($event)" @mouseout="outStyle($event)">
          <div class="case-img" :data-id="index" @mouseover="selectStyle($event)" @mouseout="outStyle($event)">
            <img :src="item.advantageImg" :data-id="index" @mouseover="selectStyle($event)" @mouseout="outStyle($event)">
          </div>
          <div class="case-text" :data-id="index" @mouseover="selectStyle($event)" @mouseout="outStyle($event)">{{item.advantageTitle}}</div>
          <div class="inner-text" :class="{'is-show':index == show}" :data-id="index" @mouseover="selectStyle($event)" @mouseout="outStyle($event)">
            <div class="inner-title" :data-id="index" @mouseover="selectStyle($event)" @mouseout="outStyle($event)">{{item.advantageTitle}}</div>
            <div class="inner-content" :data-id="index" @mouseover="selectStyle($event)" @mouseout="outStyle($event)">{{item.advantageText}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import axios from 'axios'
var CONFIG = require('../../common/config.js')
var base_url = CONFIG.API_URL.BASE_URL
var img_url = CONFIG.API_URL.IMG_URL;

export default {
  data () {
    return {
      serviceInfo: '',
      service: '',
      show: 1000,
      secbanner: [],
      introduceInfo: [],
      advantageInfo: [],
      scenarioInfo: [],
      caseInfo: [],
      holdInfo: [],
      platformInfo: [],
      userValueInfo: [],
      indexId: this.$route.query.id,
      headImg: [
        {
          id: 1,
          img: '../../static/images/ziXun.png'
        },
        {
          id: 2,
          img: '../../static/images/yunYing.png'
        },
        {
          id: 3,
          img: '../../static/images/zhiChen.png'
        },
        {
          id: 4,
          img: '../../static/images/jianShen.png'
        },
        {
          id: 25,
          img: '../../static/images/xieTong.png'
        }
      ]
    }
  },
  created: function (options) {
    var that = this
    // 获取产品简介
    that.getGoodsServiceInfo()
    // that.getGoodsAdvantageInfo()
  },
  watch: {
    $route: function () {
      var that = this
      // 获取服务支持
      that.getGoodsServiceInfo()
      this.indexId = this.$route.query.id
      // that.getGoodsAdvantageInfo()
    }
  },
  methods: {
    // 获取服务支持
    getGoodsServiceInfo: function () {
      var that = this
      // 页面携带参数
      var id = this.$route.query.id
      that.id = id
      axios.post(base_url + 'front/getGoodsServiceInfo', {'cate': id}).then(function (res) {
        if (res.data.code == 0) {
          var dataInfo = res.data.result
          // console.log(dataInfo, '11111')
          // 处理二级导航栏
          let secArr = []
          for (let i = 0; i < dataInfo.length; i++) {
            if (secArr.indexOf(dataInfo[i]['title']) === -1) {
              secArr.push(dataInfo[i]['title'])
            }
          }
          secArr.push('联系我们')
          that.secbanner = secArr
          let introduceArr = []
          let advantageArr = []
          let scenarioArr = []
          let caseArr = []
          let holdArr = []
          let platformArr = []
          let userValueArr = []
          for (let k = 0; k < dataInfo.length; k++) {
            if (dataInfo[k]['type'] == 1) {
              introduceArr.push(dataInfo[k])
            } else if (dataInfo[k]['type'] == 2) {
              advantageArr.push(dataInfo[k])
            } else if (dataInfo[k]['type'] == 3) {
              scenarioArr.push(dataInfo[k])
            } else if (dataInfo[k]['type'] == 4) {
              caseArr.push(dataInfo[k])
            } else if (dataInfo[k]['type'] == 5) {
              platformArr.push(dataInfo[k])
            } else if (dataInfo[k]['type'] == 6) {
              holdArr.push(dataInfo[k])
            } else if (dataInfo[k]['type'] == 7) {
              userValueArr.push(dataInfo[k])
            }
          }
          for (let j = 0; j < introduceArr.length; j++) {
            introduceArr[j]['advantageImg'] = img_url + introduceArr[j]['advantageImg']
          }
          that.introduceInfo = introduceArr
          for (let a = 0; a < advantageArr.length; a++) {
            advantageArr[a]['advantageImg'] = img_url + advantageArr[a]['advantageImg']
          }
          that.advantageInfo = advantageArr
          for (let b = 0; b < scenarioArr.length; b++) {
            scenarioArr[b]['advantageImg'] = img_url + scenarioArr[b]['advantageImg']
          }
          that.scenarioInfo = scenarioArr
          for (let c = 0; c < caseArr.length; c++) {
            caseArr[c]['advantageImg'] = img_url + caseArr[c]['advantageImg']
          }
          that.caseInfo = caseArr
          for (let d = 0; d < holdArr.length; d++) {
            holdArr[d]['advantageImg'] = img_url + holdArr[d]['advantageImg']
          }
          that.holdInfo = holdArr
          for (let e = 0; e < platformArr.length; e++) {
            platformArr[e]['advantageImg'] = img_url + platformArr[e]['advantageImg']
          }
          that.platformInfo = platformArr
          for (let f = 0; f < userValueArr.length; f++) {
            userValueArr[f]['advantageImg'] = img_url + userValueArr[f]['advantageImg']
          }
          that.userValueInfo = userValueArr
        }
      }).catch(function (err) {
        // console.log(err);
      })
    },


    // 鼠标hover事件
    selectStyle ($event) {
      this.show = $event.target.dataset.id
    },
    outStyle ($event) {
      this.show = 1000
    }
  }
}
</script>

<style scoped>
  @import url("./service.css");
</style>



// WEBPACK FOOTER //
// src/views/service/service.vue